import { useTheme } from "@amx/ux-twoui-theming";
import { TextField as FluentTextField } from "@fluentui/react";
import React from "react";
import { useComponentLogger } from "../../../shared/logging";
import { validateProps } from "../../../shared/props";
import { TextFieldBaseProps } from "../shared/props";
import { getTextFieldStyles } from "../shared/styles";

export interface TextAreaProps extends TextFieldBaseProps {
    /** Number of rows our text area should have */
    readonly numberOfRows?: number;
}

export const TextArea: React.FC<TextAreaProps> = ({
    "aria-label": ariaLabel,
    "data-bi-id": biId,
    value,
    description,
    placeholder,
    disabled = false,
    onChange,
    label,
    numberOfRows,
    ...otherProps
}) => {
    const theme = useTheme();
    useComponentLogger("TextArea", otherProps.id);

    validateProps("TextArea", otherProps);

    return (
        <FluentTextField
            multiline={true}
            rows={numberOfRows}
            label={label}
            ariaLabel={ariaLabel}
            description={description}
            placeholder={placeholder}
            disabled={disabled}
            onChange={onChange}
            value={value}
            styles={getTextFieldStyles(theme, disabled || false)}
            {...otherProps}
        />
    );
};
